import type { RouteDef } from '../router';
import { getLegal } from '../data/legal';
import { t } from '../i18n';
import { legalPageHtml } from '@roamzy/shared';

/**
 * Legal pages. Mostly placeholder until real legal review, so every one
 * carries the draft banner. Content is per-locale via data/legal.ts; the
 * markup is shared with the server (shared/about-legal-page.ts).
 */
function page(kind: 'terms' | 'privacy'): string {
  const legal = getLegal();
  return legalPageHtml({ kind, doc: legal[kind], banner: legal.draftBanner, volume: t('footer.legal') });
}

export const legalTerms: RouteDef = {
  path: '/legal/terms',
  routeType: 'faq',
  metaTitle: 'Terms of Service — Roamzy',
  metaDesc: 'Terms of service for Roamzy global eSIM.',
  prerenderMarker: '.legal-route--terms',
  hydrate: () => '',
  render: () => page('terms'),
};

export const legalPrivacy: RouteDef = {
  path: '/legal/privacy',
  routeType: 'faq',
  metaTitle: 'Privacy Policy — Roamzy',
  metaDesc: 'Privacy policy for Roamzy global eSIM.',
  prerenderMarker: '.legal-route--privacy',
  hydrate: () => '',
  render: () => page('privacy'),
};
